import React from "react";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const DrivePartiesDropdown = ({
  resources,
  driveParty,
  driveParties,
  onDrivePartyChange,
  containerClass,
  labelText = null,
  defaultValue = null,
  id = "driveParties-dropdown",
  disabled = false,
  required = false,
  addMarginBottom = false,
  filterFunction = null,
  helperText = null,
  noPlaceholder = false,
}) => {
  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={labelText ?? resources["DriveParties"]}
      value={driveParty}
      values={driveParties}
      placeholder={noPlaceholder ? null : defaultValue ?? resources["All"]}
      inputName="driveParty"
      handleChange={onDrivePartyChange}
      addMarginBottom={addMarginBottom}
      disabled={disabled}
      required={required}
      containerClass={containerClass}
      filter={filterFunction}
      helperText={helperText}   
      map={(a) => ({ key: a.id, name: a.description })}
      sort={(a, b) =>
        a.description.toLowerCase().localeCompare(b.description.toLowerCase())
      }
    />
  );
};

export default DrivePartiesDropdown;
